import { createActions } from 'redux-actions';

export const {
  updateImageSearchResult,
  updateImageInstances,
  updateImagesSearchResult,
  updateImagesNextPage,
  updateModels,
  updateSelectedModel,
  updateCurrentImageNode,
  clearCurrentImageNode,
  viewNextImage,
  viewPreviousImage,
  clearImage,
  searchImage,
  searchImages,
  searchImagesNextPage,
  searchComplete,
  searchCancel,
  searchTimeout,
  searchFailure,
  selectImage,
  selectAllImages,
  updateSelectedImages,
  deselectImage,
  clearImageSelection,
  toggleAutoSearch
} = createActions({
  UPDATE_IMAGE_SEARCH_RESULT: response => response,
  UPDATE_IMAGE_INSTANCES: response => response,
  UPDATE_IMAGES_SEARCH_RESULT: response => response,
  UPDATE_IMAGES_NEXT_PAGE: response => response,
  UPDATE_MODELS: response => response,
  UPDATE_SELECTED_MODEL: input => input,
  UPDATE_CURRENT_IMAGE_NODE: imageID => imageID,
  CLEAR_CURRENT_IMAGE_NODE: () => undefined,
  VIEW_NEXT_IMAGE: () => undefined,
  VIEW_PREVIOUS_IMAGE: () => undefined,

  CLEAR_IMAGE: () => undefined,
  SEARCH_IMAGE: id => id,
  SEARCH_IMAGES: () => undefined,
  SEARCH_IMAGES_NEXT_PAGE: () => undefined,
  SEARCH_COMPLETE: () => undefined,
  SEARCH_CANCEL: () => undefined,
  SEARCH_TIMEOUT: () => undefined,
  SEARCH_FAILURE: () => undefined,

  SELECT_IMAGE: id => id,
  SELECT_ALL_IMAGES: () => undefined,
  UPDATE_SELECTED_IMAGES: arrayOfID => arrayOfID,
  DESELECT_IMAGE: id => id,
  CLEAR_IMAGE_SELECTION: () => undefined,

  TOGGLE_AUTO_SEARCH: () => undefined
});



// WEBPACK FOOTER //
// ./src/actions/SearchFieldActions.js